import { createApp } from 'vue';
import VueCookies from 'vue-cookies';
import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import { message } from 'ant-design-vue';
import { initializeApp } from 'firebase/app';
import VueSocialSharing from 'vue-social-sharing';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import App from '@/App.vue';
import { i18n } from '@/lang';
import { router } from '@/router';
import { store } from '@/store';
import { amplitudeInstance } from '@/analytics';
import { createSvgIconSprite } from '@/assets/icons';

import '@/api/config'; // set axios
import '@/scss/index.scss';

createSvgIconSprite();

const app = createApp(App);
const metaManager = createMetaManager();

app.use(store);
app.use(router);
app.use(VueCookies, { expires: '1m' });
app.use(metaManager);
app.use(metaPlugin);
app.use(VueSocialSharing);
app.use(i18n);

app.directive('click-outside', {
  mounted(el, binding) {
    el.clickOutsideEvent = function (event: Event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

app.config.globalProperties.$amplitude = amplitudeInstance;
app.config.globalProperties.$message = message;

// Initialize Firebase
initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
});

(async () => {
  const deviceId = await FingerprintJS.load()
    .then((fp) => fp.get())
    .then(({ visitorId }) => visitorId);

  amplitudeInstance.setDeviceId(deviceId);

  app.mount('#app');
})();
